import React, { ButtonHTMLAttributes, ReactNode } from 'react';

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: ReactNode;
};

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  type = 'button',
  ...buttonProps
}) => {
  return (
    <button type={type} {...buttonProps}>
      {icon}
    </button>
  );
};

export default IconButton;

